import './polyfills.js';
import 'design-assets/css/vf.scss';
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import { initializeRouter } from './router';
import { initializeStore } from './store/store';
import { installPlugins } from './plugins/plugins';
import { loadAppContext } from './loaders.js';
import { config } from 'config';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

Vue.config.productionTip = false;
const getStore = () =>
    loadAppContext()
        .then(initializeStore)
        .catch((error) => {
            console.log(error); // eslint-disable-line no-console
        });

getStore().then((store) => {
    const router = initializeRouter(store);
    installPlugins(Vue);

    sync(store, router);

    new Vue({
        router,
        store,
        render: (h) => h(App),
    }).$mount('#app');
});

if (config.isSentryEnabled) {
    Vue.config.errorHandler = function(error, vm, info) {
        console.error(error, vm, info); // eslint-disable-line no-console
    };

    // TODO: possible deprecation in near future (2023)
    // https://viafoura.slack.com/archives/C0191TCD9PV/p1665157165849409

    // Sentry.init({
    //     dsn: config.sentry_dsn,
    //     debug: true,
    //     environment: config.environment,
    //     // eslint-disable-next-line no-undef
    //     release: `viafoura-console@${_CONSOLE_VERSION_}`, // this cool constant is from webpack
    //     integrations: [ new Integrations.Vue({
    //         Vue,
    //         attachProps: true,
    //         logErrors: true,
    //     }) ],
    // });
}
